





























































import { defineComponent, computed } from '@vue/composition-api';
import { useAllowlist, generateCustomLink, OriginalQuery, generateLegacyWeblink } from '@tt4b/ttam-hooks';

const name = 'ttam-creative-utm-dialog-footer';

export default defineComponent({
  name,
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
    showCustomLink: {
      type: Boolean,
      default: true,
    },
    showProductLink: {
      type: Boolean,
      default: true,
    },
    pureUrl: {
      type: String,
      default: '',
    },
    pureParams: {
      type: String,
      default: '',
    },
    paramsArray: {
      type: Array,
      default: () => [],
    },
    originalQuery: {
      type: Array,
      default: () => [],
    },
    isLegacy: {
      type: Boolean,
      default: false,
    },
    isProductDeeplink: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { isUtmBuilderWhite } = useAllowlist();
    const customLink = generateCustomLink(props.originalQuery as OriginalQuery[], props.paramsArray, props.pureUrl);
    const legacyWeblink = computed(() =>
      generateLegacyWeblink(props.originalQuery as OriginalQuery[], props.pureParams, props.pureUrl),
    );
    return {
      isUtmBuilderWhite,
      customLink,
      legacyWeblink,
      name,
    };
  },
});
